import { render, staticRenderFns } from "./planlobby.vue?vue&type=template&id=048ff52b&scoped=true&"
import script from "./planlobby.vue?vue&type=script&lang=js&"
export * from "./planlobby.vue?vue&type=script&lang=js&"
import style0 from "@/assets/planlobby.scss?vue&type=style&index=0&id=048ff52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ff52b",
  null
  
)

export default component.exports